module.exports = __webpack_public_path__ + "de8a7b92c8c594c0bad6ce9c38e698f1.jpg";